module.exports = __webpack_public_path__ + "first-20_uv_back.jpg?7e07ec040d543cf8d558b7b49a7de773";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_uv_back.jpg
// module id = 508
// module chunks = 0